
import {
    setIsLogin,
    SetUserInfo,
  } from "@/employee/components/state/actions/login";
import { store } from "@/web/components/state/store";

export const handleLogout = () => {
    store.dispatch(setIsLogin(null));
    store.dispatch(SetUserInfo(null));
};